/**
 * GiftDashboardContainer
 * --
 */
import React from 'react';
import GiftDashboardPresenter from './GiftDashboardPresenter';

const GiftDashboardContainer = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      <GiftDashboardPresenter />
    </>
  );
};

export default GiftDashboardContainer;
